const MarketReport=()=>{
    return(
        <iframe src="https://search.realzon.net/idx/market-reports" width="100%" height="1200" scrolling="yes"></iframe>
    )
}

export default MarketReport;